import ApplicationController from "../../application_controller.js";
import { formValidation } from "@form-validation/bundle/popular";
import { Bootstrap5 } from "@form-validation/plugin-bootstrap5";
import { Trigger } from "@form-validation/plugin-trigger";
import { AutoFocus } from "@form-validation/plugin-auto-focus";
import { useI18n } from "mixins";
import translations from "../../../locales/view_components/formvalidation-contact.json";

export default class extends ApplicationController  {

  initialize() {
    this.log_function("initialize");

    useI18n({
      controller: this,
      translations: translations,
      scope: "activemodel.errors.models.temporary/contact_form.attributes",
    });

    this.boundFormSubmit = this.formSubmit.bind(this);
    this.element.addEventListener("submit", this.boundFormSubmit);

    this.instance = formValidation(this.element, {
      fields: {
        "contact[full_name]": {
          validators: {
            notEmpty: {
              message: this.t("full_name.blank"),
            },
          },
        },
        "contact[email]": {
          validators: {
            emailAddress: {
              message: this.t("email.invalid"),
              requireGlobalDomain: true,
            },
            notEmpty: {
              message: this.t("email.blank"),
            },
          },
        },
        "contact[message]": {
          validators: {
            stringLength: {
              message: this.t("message.too_long", { count: 1000 }),
              max: 1000,
            },
            notEmpty: {
              message: this.t("message.blank"),
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger({
          event: "blur",
        }),
        bootstrap: new Bootstrap5({
          rowSelector: ".form-group",
        }),
        autoFocus: new AutoFocus(),
      },
    });

  }

  formSubmit(event) {
    this.log_function("formSubmit");

    //* Using a custom submit event in order for turbo to use the correct submit handler rather than the formvalidation.io submit events
    //* See this link for details: https://discuss.hotwired.dev/t/triggering-turbo-frame-with-js/1622/15

    this.instance.validate()
    .then((status) => {
      if(status != "Valid"){
        event.preventDefault();
      }
      return status;
    })
    .catch((error) => {
      this.log_error_function("formSubmit", error);
    });
  }

  disconnect(){
    this.log_function("disconnect");

    this.instance.deregisterPlugin("___frameworkMessage"); // BUG added this to resolve a bug
    this.instance.destroy();
    this.element.removeEventListener("submit", this.boundFormSubmit);
  }
}
